import * as React from 'react';
import { Tooltip } from 'react-leaflet';
import styled from 'styled-components';

const LabelContents = styled.span`
  background: white;
  border-radius: 2px;
  padding: 2px;
  white-space: nowrap;
`;

type Props = {
  text: string;
}
export const LabelTooltip: React.SFC<Props> = ({ text }) => {
  return (
    <Tooltip permanent direction={'center'}>
      <LabelContents>
        { text }
      </LabelContents>
    </Tooltip>
  )
};



// WEBPACK FOOTER //
// ./src/labeling-screen/label-tooltip.tsx